import { useRef, useCallback, useEffect } from 'react'

export function useScrollPosition() {
  const tableScrollRef = useRef(null)
  const scrollPosRef = useRef({ left: 0, top: 0 })
  const isRestoredRef = useRef(false)

  const captureScrollPosition = useCallback(() => {
    const el = tableScrollRef.current
    if (!el) return
    scrollPosRef.current = { left: el.scrollLeft, top: el.scrollTop }
  }, [])

  // Only restore scroll position on first mount, not after every render.
  // Previously this had no deps array → ran after every render, canceling
  // any scroll changes made by keyboard navigation (ensureVisible).
  useEffect(() => {
    if (isRestoredRef.current) return
    const el = tableScrollRef.current
    if (!el) return
    el.scrollLeft = scrollPosRef.current.left
    el.scrollTop = scrollPosRef.current.top
    isRestoredRef.current = true
  }, [])

  const scrollToRight = useCallback(() => {
    requestAnimationFrame(() => {
      const el = tableScrollRef.current
      if (el) {
        el.scrollLeft = el.scrollWidth
      }
    })
  }, [])

  return { tableScrollRef, captureScrollPosition, scrollToRight }
}
